<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_VIEW_DATA')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết thanh toán T+2</h1>
      <div class="btn-group float-right">
        <button
          @click="updateResultModal = true"
          v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_SUPPORT_T2')"
          class="f12 font-medium btn btn-outline-primary"
        >
          Cập nhật tình trạng
        </button>
        <button
          @click="$router.push('/calendar-afs/create')"
          v-if="dataPermission.includes('CNPS_CALENDAR_AFS_INSERT')"
          class="f12 font-medium btn btn-outline-secondary"
        >
          Tạo công việc chăm sóc
        </button>
        <button
          @click="$bvModal.show('assign-modal')"
          v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_ASSIGN_USER')"
          class="f12 font-medium btn btn-outline-secondary"
        >
          Gán NV xử lý
        </button>
        <button
          @click="assignToMe"
          v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_SELF_ASSIGN')"
          class="f12 font-medium btn btn-outline-secondary"
        >
          Nhận việc
        </button>
        <button @click="checkStatus(id)" class="f12 font-medium btn btn-outline-secondary">
          Kiểm tra TT Thanh toán
        </button>
        <button
          @click="$router.push('/payment-T2')"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin Merchant</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.merchantInfo && detailText.merchantInfo.name }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.merchantInfo && detailText.merchantInfo.addressBiz }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Email<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.merchantInfo && detailText.merchantInfo.email }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số điện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.merchantInfo && detailText.merchantInfo.mobile }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Nhân viên xử lý<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="detailText.assigneeInfo && detailText.assigneeInfo.name"
                >
                  <span>{{ detailText.assigneeInfo.name }}</span> -
                  <span> {{ detailText.assigneeInfo.email }}</span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Điểm chấp nhận thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{
                    detailText.merchantInfo && detailText.merchantInfo.bizArea
                      ? detailText.merchantInfo.bizArea.join(', ')
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <b-badge v-if="detailText.announced" pill variant="success">Đã thông báo</b-badge>
                  <b-badge v-else pill variant="warning">Chưa thông báo</b-badge>
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin giao dịch MPOS</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã giao dịch MPOS<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.tranTxnId }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số tiền giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.amount | fomatCurrency }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Loại giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.tranTypeText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Phương thức thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.paymentMethodText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.statusText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Loại rủi ro<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detailText.riskTypeText }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin thẻ thanh toán</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên chủ thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.cardInfo && detailText.cardInfo.holderName }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.cardInfo && detailText.cardInfo.number }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Loại thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.cardInfo && detailText.cardInfo.type }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <div class="form-detail" v-if="detailAction.length > 0">
            <h1>Lịch sử liên hệ</h1>
            <div class="table-responsive">
              <table class="table table-hover table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th>Thời gian</th>
                    <th>Hình thức</th>
                    <th>Kết quả</th>
                    <th>Ghi chú</th>
                    <th>Người thực hiện</th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in detailAction" :key="index">
                  <tr>
                    <td>{{ item.supportAt }}</td>
                    <td>{{ item.methodText }}</td>
                    <td>{{ item.resultText }}</td>
                    <td>{{ item.note }}</td>
                    <td>
                      {{ item.supportName }}<br />
                      <span class="text-primary">{{ item.supportEmail }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal thông báo-->
    <b-modal :no-enforce-focus="true" id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
        <b-button variant="primary" @click="$router.push('/payment-T2')" v-if="backList">
          Quay lại danh sách
        </b-button>
      </template>
    </b-modal>

    <!-- Modal cập nhật tình trạng-->
    <b-modal :no-enforce-focus="true" id="update-result" v-model="updateResultModal">
      <template #modal-header="{}">
        <h5>Xác nhận đã thông báo cho MC</h5>
        <b-button size="sm" variant="light" @click="resetFormResult"> x </b-button>
      </template>
      <div>
        <ValidationObserver class="w-100" ref="formResult">
          <form @submit.prevent="submitUpdate">
            <ValidationProvider rules="required" vid="method" name="Hình thức thông báo">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Hình thức thông báo<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <Select2 v-model="updateResult.method" :options="optionMethods"></Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="supportAt" name="Ngày thông báo">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Ngày thông báo<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <date-picker v-model="supportAt" :config="optionsDatePicker"></date-picker>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="result" name="Kết quả">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Kết quả<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <Select2 :options="optionResult" v-model="updateResult.result"></Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="minMaxName_4" vid="note" name="Ghi chú">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label">Ghi chú</label>
                <div class="col-sm-8">
                  <input v-model.trim="updateResult.note" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <template #modal-footer="{}">
        <b-button variant="light" @click="resetFormResult"> Đóng </b-button>
        <b-button variant="primary" @click="submitUpdate"> Xác nhận </b-button>
      </template>
    </b-modal>

    <!--gán nhân viên-->
    <b-modal :no-enforce-focus="true" id="assign-modal">
      <template #modal-header="{ close }">
        <h5>Gán nhân viên xử lý</h5>
        <b-button size="sm" variant="outline-light" @click="close()">x</b-button>
      </template>

      <template #default="{}">
        <div class="form-group row">
          <div class="col-sm-12">
            <b-input-group>
              <b-form-input
                placeholder="Tên/Email"
                v-model="searchSale.textSearch"
                @input="listStaff"
                @keyup.enter="listStaff"
              >
              </b-form-input>
              <b-input-group-append>
                <b-button variant="outline-secondary">Tìm kiếm</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="table-responsive m-3" style="max-height: 50vh; overflow-y: auto">
            <b-table
              hover
              :items="dataSale"
              :fields="fields"
              :sticky-header="true"
              class="b-table-select-single"
              id="table-sale"
              selectable
              select-mode="single"
              @row-selected="onStaffSelected"
              :per-page="searchSale.limit"
              :current-page="searchSale.page"
              small
            >
            </b-table>
          </div>
          <b-pagination
            class="ml-3"
            v-model="searchSale.page"
            :total-rows="total"
            :per-page="searchSale.limit"
            aria-controls="table-sale"
          ></b-pagination>
        </div>
      </template>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="primary" @click="assignToSale" :disabled="idAssign === ''">
          Xác nhận
        </b-button>
        <b-button size="sm" variant="light" @click="cancel()"> Huỷ </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { LicenceService } from '@/services/licence.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import Config from '@/thirdParty/config'
  import datePicker from 'vue-bootstrap-datetimepicker'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin'
  import moment from 'moment'

  export default {
    data() {
      return {
        loading: false,
        id: this.$route.params.id,
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        detailText: {},
        detailAction: [],
        updateResultModal: false,
        optionMethods: Config.methodT2,
        optionsDatePicker: {
          format: 'DD/MM/YYYY HH:mm',
          useCurrent: true,
        },
        optionResult: Config.resultT2,
        supportAt: null,
        updateResult: {},
        dataSale: [],
        fields: [
          {
            label: 'Tên',
            key: 'name',
            thStyle: { 'min-width': '140px', 'word-break': 'break-word' },
          },
          { label: 'Email', key: 'userName' },
          { label: 'Tỉnh/Thành phố', key: 'provinceName' },
        ],
        idAssign: '',
        searchSale: {
          limit: 20,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
        total: 0,
        backList: false,
      }
    },

    components: {
      datePicker,
    },

    created() {
      this.fetchData()
      this.listStaff()
    },
    watch: {
      'searchSale.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.listStaff()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.searchSale.limit,
          page: this.searchSale.page,
        })
      },
    },
    mixins: [prepareQueryParamsMixin],
    methods: {
      async checkStatus(id) {
        try {
          this.loading = true
          const response = await LicenceService.checkStatus(id)
          this.showSuccessMx(`Trạng thái thông tin: ${response.data.statusText}`)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      onStaffSelected(item) {
        this.idAssign = item.length > 0 ? item[0].userId : ''
      },
      async listStaff() {
        try {
          const data = await StaffService.getListLowerGrade(this.searchSale)
          if (data.success) {
            this.total = data.data.length
            this.dataSale = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
      async assignToSale() {
        try {
          this.$bvModal.hide('assign-modal')
          this.loading = true
          const data = await LicenceService.assignSale({
            licenceIds: [this.id],
            userId: this.idAssign,
            isSelfAssign: false,
          })
          if (data.success) {
            this.idAssign = ''
            this.successModal('Gán nhân viên xử lý thành công')
            this.backList = true
            await this.fetchData()
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async assignToMe() {
        try {
          this.loading = true
          const data = await LicenceService.assignSelf({
            licenceIds: [this.id],
            userId: this.searchSale.userId,
            isSelfAssign: true,
          })
          if (data.success) {
            this.successModal('Nhận việc thành công')
            await this.fetchData()
            this.backList = true
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const data = await LicenceService.detailT2({
            licenceId: this.id,
          })
          if (data.success) {
            this.detailText = data.data.licence
            this.detailAction = data.data.actionSupportHistory
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async submitUpdate() {
        try {
          this.updateResult.supportAt = moment(
            this.supportAt,
            this.optionsDatePicker.format
          ).valueOf()
          const isSuccess = await this.$refs.formResult.validate()
          if (!isSuccess) {
            return
          }
          this.loading = true
          this.updateResult.licenceId = [this.id]
          const data = await LicenceService.changeResult(this.updateResult)
          if (data.success) {
            this.resetFormResult()
            this.successModal('Cập nhật tình trạng thành công')
            await this.fetchData()
            this.supportAt = null
          } else {
            this.resetFormResult()
            this.errorModal(data.message)
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      resetFormResult() {
        this.updateResultModal = false
        this.updateResult = {}
        // this.$refs.formResult.reset()
      },
      successModal(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = msg
      },
      errorModal(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = msg
      },
    },
  }
</script>
<style scoped>
  ul.b {
    list-style-type: square !important;
  }
</style>
